module.exports = __webpack_public_path__ + "static/media/bg-choose-power.ab0dba89.jpg";